<template>
  <div>
    <div class="d-flex">
      <div class="mr-auto">
        <button class="btn btn-secondary" @click="refresh">
          <i class="fas fa-sync-alt fa-fw"></i>
        </button>
        <button class="btn btn-purple" v-if="canCreate" @click="onCreate">
          <i class="far fa-file fa-fw"></i>
        </button>
      </div>
      <div class="align-self-end d-flex">
        <el-select
          v-model="statusFilter"
          placeholder="All statuses"
          clearable
          class="w-150 mr-2 mb-2"
        >
          <el-option label="Pending" value="pending"></el-option>
          <el-option label="Approved" value="approved"></el-option>
          <el-option label="Rejected" value="rejected"></el-option>
        </el-select>
        <input-debounced
          v-model="search"
          :clearable="true"
          :autofocus="true"
          placeholder="Search"
          class="search-bar w-300 mb-2"
        ></input-debounced>
      </div>
    </div>
    <base-table
      :base-url="urlWithFilters"
      ref="baseTable"
      @load-success="onLoadSuccess"
      @refresh="onRefresh"
      :current-page="currentPage"
      v-loading="isRefreshing"
      element-loading-spinner="el-icon-loading"
    >
      <template v-slot>
        <el-table :data="items" stripe class="w-100">
          <el-table-column
            prop="model.id"
            label="Id"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="model.user.email"
            label="Author"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="model.content"
            label="Content"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="Status"
            width="110"
            v-slot="{
              row: {
                model: { status },
              },
            }"
          >
            <el-tag :type="statusType(status)" size="small">{{ status }}</el-tag>
          </el-table-column>
          <el-table-column
            label="Brands"
            v-slot="{
              row: {
                model: { brands },
              },
            }"
            min-width="100"
          >
            <brand-column :brands="brands"></brand-column>
          </el-table-column>
          <el-table-column
            label="Tags"
            v-slot="{
              row: {
                model: { tags },
              },
            }"
            min-width="100"
          >
            <tags-column :tags="tags"></tags-column>
          </el-table-column>
          <el-table-column
            prop="model.created_at"
            label="Created At"
            width="124"
            :formatter="formatDate"
          ></el-table-column>
          <el-table-column
            prop="model.updated_at"
            label="Updated At"
            width="124"
            :formatter="formatDate"
          ></el-table-column>
          <el-table-column label="Actions" v-slot="{ row }" width="160">
            <actions-column
              :row="row"
              @edit="onEdit"
              @delete="onDelete"
              @approve="onApprove"
              @reject="onReject"
            ></actions-column>
          </el-table-column>
        </el-table>
      </template>
    </base-table>
    <el-pagination
      layout="prev, pager, next"
      :total="total"
      :current-page.sync="currentPage"
      :page-size="pageSize"
      class="text-right"
    ></el-pagination>
  </div>
</template>

<script>
import BaseTable from "../../../components/approved-message/table";
import ActionsColumn from "../../../components/approved-message/actions-column";

export default {
  extends: BaseTable,

  components: {
    ActionsColumn,
  },

  props: {
    canCreate: Boolean,
    createUrl: String,
  },

  data() {
    return {
      statusFilter: new URLSearchParams(window.location.search).get("status"),
    };
  },

  watch: {
    statusFilter: {
      immediate: true,
      handler(current) {
        this.filters = current
          ? _.assign({}, this.filters, { status: current })
          : _.omit(this.filters, ["status"]);

        this.syncStatusInUrl(current);
      },
    },
  },

  methods: {
    /**
     * Keep the address bar in sync with the status filter so clearing the
     * select also drops ?status= from the URL; otherwise a refresh would
     * re-read the stale param and re-apply the filter.
     *
     * @param {string|null} status
     */
    syncStatusInUrl(status) {
      const params = new URLSearchParams(window.location.search);

      if (status) {
        params.set("status", status);
      } else {
        params.delete("status");
      }

      const query = params.toString();

      window.history.replaceState(
        window.history.state,
        "",
        query
          ? `${window.location.pathname}?${query}`
          : window.location.pathname
      );
    },

    /**
     * @param {string} status
     * @return {string}
     */
    statusType(status) {
      return (
        {
          pending: "warning",
          approved: "success",
          rejected: "danger",
        }[status] || "info"
      );
    },
  },

  created() {
    eventBus.$on("refresh-approved-message-table", this.refresh);
  },

  beforeDestroy() {
    eventBus.$off("refresh-approved-message-table", this.refresh);
  },
};
</script>
